import { Sparkles, Zap, Shield, Heart, TrendingUp, Users } from "lucide-react";

const Benefits = () => {
  const benefits = [
    {
      icon: Sparkles,
      title: "AI-Powered Creativity",
      description: "Our advanced AI understands trends and creates usernames and bios that resonate with your audience"
    },
    {
      icon: Zap,
      title: "Lightning Fast",
      description: "Get 5 usernames and 5 bios in seconds. No waiting around, just instant creative inspiration"
    },
    {
      icon: Shield,
      title: "100% Private & Secure",
      description: "We don't store your data or require login. Your privacy is our priority"
    },
    {
      icon: Heart,
      title: "Completely Free",
      description: "No subscriptions, no hidden fees, no paywalls. Full access to all features, always free"
    },
    {
      icon: TrendingUp,
      title: "Trend-Aware",
      description: "Our AI stays updated with current social media trends to keep your profile fresh and relevant"
    },
    {
      icon: Users,
      title: "For Everyone",
      description: "Perfect for influencers, gamers, businesses, students, and anyone building an online presence"
    }
  ];

  return (
    <section className="w-full py-16 bg-gradient-to-b from-background to-accent/20" id="benefits">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
          Why Thousands Choose NameBioLab
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
          The most powerful, easy-to-use <a href="#generator" className="text-primary hover:underline">username and bio generator</a> trusted by content creators worldwide
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div 
                key={benefit.title}
                className="flex flex-col items-center text-center space-y-4 p-6 rounded-lg bg-card/50 backdrop-blur-sm animate-fade-in"
              >
                <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center">
                  <Icon className="w-7 h-7 text-primary" />
                </div>
                <h3 className="text-xl font-semibold">{benefit.title}</h3>
                <p className="text-muted-foreground">{benefit.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
